export default {
  component: () => import('./page.vue'),
  path: '/sdk',
  name: 'error-sdk',
  meta: {
    title: '页面错误',
  },
};
